import { Action } from '@ngrx/store';
import { Escenarios } from 'src/app/models/SicarMap/Escenario/Escenarios.modelo';


export enum AddSceneTypes {
  SCENE_ADD = '[SCENE] Add',
  SCENE_ADD_SUCCESS = '[SCENE] AddSucces',
  SCENE_ADD_FAILURE = '[SCENE] AddFailure',
  SCENE_ADD_RESET = '[SCENE] AddReset ',
}

export class AddReset implements Action {
  readonly type = AddSceneTypes.SCENE_ADD_RESET;
  constructor() {}
}
export class AddScene implements Action {
  readonly type = AddSceneTypes.SCENE_ADD;
  constructor(public Scene: Escenarios) {}
}

export class AddSuccess implements Action {
  readonly type = AddSceneTypes.SCENE_ADD_SUCCESS;
  constructor(public claveRS: number) {}
}

export class AddFailure implements Action {
  readonly type = AddSceneTypes.SCENE_ADD_FAILURE;
  constructor(public payload: any) {}
}


export type AddSceneAcciones =
  | AddScene
  | AddSuccess
  | AddFailure
  | AddReset;